import { useTranslation } from "react-i18next";

export default function PortalSessionLoader() {
  const { t } = useTranslation();
  const label = t("landing.checkingSession");

  return <div className="portal-spinner" role="status" aria-label={label} />;
}
